import { render, staticRenderFns } from "./P43.vue?vue&type=template&id=84f4e130&scoped=true"
import script from "./P43.ts?vue&type=script&lang=ts&external"
export * from "./P43.ts?vue&type=script&lang=ts&external"
import style0 from "./P43.vue?vue&type=style&index=0&id=84f4e130&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f4e130",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84f4e130')) {
      api.createRecord('84f4e130', component.options)
    } else {
      api.reload('84f4e130', component.options)
    }
    module.hot.accept("./P43.vue?vue&type=template&id=84f4e130&scoped=true", function () {
      api.rerender('84f4e130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/pages/P43/P43.vue"
export default component.exports